import { render } from "./SortUpIcon16.vue.js?vue&type=template&id=18f0c248!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./SortUpIcon16.vue?vue&type=template&id=18f0c248"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__